module.exports = __webpack_public_path__ + "static/media/professional.daffc83b.svg";